import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { Config, createStateSyncMiddleware, initStateWithPrevTab } from "redux-state-sync";
import siteReducer from "./siteSlice";
import userReducer from "./userSlice";
import { siteApiSlice } from "./siteApiSlice";
import contrastSliceReducer from "./contrastSlice";

const syncConfig: Config = {
	predicate: (action) => action.type.startsWith("user/"),
};

const rootReducer = combineReducers({
	site: siteReducer,
	user: persistReducer(
		{ key: "user", storage, blacklist: ["username", "firstName", "lastName", "initials"] },
		userReducer
	),
	[siteApiSlice.reducerPath]: siteApiSlice.reducer,
	contrast: contrastSliceReducer,
});

export const store = configureStore({
	reducer: rootReducer,
	devTools: process.env.NODE_ENV !== "production",
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false })
			.concat(createStateSyncMiddleware(syncConfig))
			.concat(siteApiSlice.middleware) as unknown as any,
});

initStateWithPrevTab(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);
